import { Link } from '@tanstack/react-router';
import { type Banner, resolveBannerLink } from '@/domain';
import { cn } from '@/lib/cn';

export interface BannerSlideProps {
  banner: Banner;
  className?: string;
}

const frameClassName =
  'relative block h-full w-full overflow-hidden rounded-[6px] bg-bg-canvas';

export function BannerSlide({ banner, className }: BannerSlideProps) {
  const link = resolveBannerLink(banner.linkUrl);
  const inner = (
    <>
      <img
        src={banner.imageUrl}
        alt=""
        className="absolute inset-0 size-full object-cover"
        draggable={false}
      />
      {banner.htmlText ? (
        <div
          className="relative z-10 flex h-full flex-col justify-between p-[15px] text-text-primary"
          dangerouslySetInnerHTML={{ __html: banner.htmlText }}
        />
      ) : null}
    </>
  );

  const classes = cn(frameClassName, className);

  if (link.kind === 'external') {
    return (
      <a href={link.href} target="_blank" rel="noopener noreferrer" className={classes}>
        {inner}
      </a>
    );
  }

  if (link.kind === 'internal') {
    return (
      <Link to={link.href as never} className={classes}>
        {inner}
      </Link>
    );
  }

  return <div className={classes}>{inner}</div>;
}
